import {Container, Text, TextBold} from './styled'
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";
import React from "react";

export default function Version(
    {uniqueCode}: { uniqueCode?: number }
) {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <Container>
            <Text color={colors.text}>Versão {ConstantsKeys.version}&nbsp;-&nbsp;
                <TextBold color={colors.text}>[{uniqueCode}]</TextBold></Text>
        </Container>
    )
}
